module.exports = __webpack_public_path__ + "img/fourCode.038389d9.png";